import { SidebarProvider } from "@medme/ui"
import type { ReactNode } from "react"

export interface LayoutProps {
	sidebar: ReactNode
	header: ReactNode
	children: ReactNode
}

/**
 * Main layout shell wrapping sidebar and content area.
 * Manages sidebar state via SidebarProvider with localStorage persistence.
 * `sidebar`/`header` are injected by the consuming app — their contents
 * (navigation items, user profile, breadcrumbs) are app-specific.
 */
export function Layout({ sidebar, header, children }: LayoutProps) {
	return (
		<SidebarProvider defaultOpen={true}>
			{/* h-screen bounds scroll to <main>; mailing form footer needs a fixed viewport chain */}
			<div className="flex h-screen w-full overflow-hidden">
				{sidebar}
				<div className="flex min-h-0 min-w-0 flex-1 flex-col">
					{header}
					<main className="min-h-0 min-w-0 flex-1 overflow-auto bg-[#F5F5F5]">
						{children}
					</main>
				</div>
			</div>
		</SidebarProvider>
	)
}
